import { AnalyticsFilterSelectController } from './analytics-filter-select.controller'

function analyticsFilterSelect () {
  return {
    restrict: 'E',
    scope: {
      options: '<',
      disabled: '<',
      value: '=',
      onFilterChange: '&'
    },
    templateUrl: '/analytics/directives/analytics-filter-select/analytics-filter-select-directive.html?$$REVISION$$',
    controller: AnalyticsFilterSelectController
  }
}

export { analyticsFilterSelect }
